import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';

import Grid from '@mui/material/Grid';
import UsersIcon from '@mui/icons-material/GroupOutlined';
import ActiveUsersIcon from '@mui/icons-material/HowToRegOutlined';
import MultiFactorEnabledIcon from '@mui/icons-material/GppGoodOutlined';

import { UsersTableContainer } from '../../components/users';
import StatsBox from '../../components/shared/StatsBox';

import { fetchDistributors, fetchManufacturers, fetchRadiology } from '../../actions/adminActions';

import './users-page.scss';

const UsersPage = (props) => {
  const {
    users, distributors, manufacturers, radiology, countryList, companies,
    fetchDistributors, fetchManufacturers, fetchRadiology, logistics, teams, currentUserId,
  } = props;

  useEffect(() => {
    fetchDistributors();
    fetchManufacturers();
    fetchRadiology();
  }, [fetchDistributors, fetchManufacturers, fetchRadiology, currentUserId]);

  const activeUsers = useMemo(() => users.filter((u) => !u.disabled), [users]);
  const multiFactorUsers = useMemo(() => users.filter((u) => !!u.multiFactorEnabled), [users]);

  return (
    <div className="users-page">
      <Grid container spacing={3} sx={{ mb: 3, display: { display: 'none', md: 'flex' } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='Total Users' number={users?.length} icon={<UsersIcon />} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='Active Users' number={activeUsers?.length} icon={<ActiveUsersIcon />} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='2FA Enabled Users' number={multiFactorUsers?.length} icon={<MultiFactorEnabledIcon />} />
        </Grid>
      </Grid>
      <UsersTableContainer
        users={users}
        distributors={distributors}
        countries={countryList}
        manufacturers={manufacturers}
        logistics={logistics}
        radiology={radiology}
        companies={companies}
        teams={teams}
        withButton
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  users: state.users.list,
  distributors: state.distributors.list,
  countryList: state.countries.list,
  manufacturers: state.manufacturers.list,
  logistics: state.logistics.list,
  radiology: state.radiology.list,
  companies: state.companies.list,
  teams: state.teams.list,
  currentUserId: state.user.currentUser?.uid,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDistributors: () => dispatch(fetchDistributors()),
  fetchManufacturers: () => dispatch(fetchManufacturers()),
  fetchRadiology: () => dispatch(fetchRadiology()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPage);
